import { z } from 'zod';

export const creditSchema = z.object({
  modeloCorrecaoGrupoId: z.number(),
  nomModeloCorrecaoGrupo: z.string(),
  qtdCreditoAdquirido: z.number(),
  qtdCreditoDisponivel: z.number(),
});

export type Credit = z.infer<typeof creditSchema>;

export const creditsResponseSchema = z.array(creditSchema);

export type CreditsResponse = z.infer<typeof creditsResponseSchema>;
